// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@stoneage/XDL/types";
import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";
import { getProp } from "@insite/mobius/utilities";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: "ChevronDown",
            color: "common.ui7",
            css: css`
                transition: all ${getProp("theme.transition.duration.short")}ms ease-in-out;
            `,
        },
        css: css`
            cursor: pointer;
            &&&&& {
                &[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
            }
        `,
    },
} as xBaseTheme["select"];
